import * as moment from 'moment';

export const truckGraphTypes = [
  {
    name: 'Area',
    id: 'area'
  },
  {
    name: 'Bar',
    id: 'bar'
  },
  {
    name: 'Line',
    id: 'line'
  },
  {
    name: 'Step',
    id: 'step'
  }
];

export const xAxisOptions = [
  {
    name: `24 Hour Format: ${moment().format('HH') ? moment().format('HH') + ':00' : '08:00'}`,
    id: '24Hours'
  },
  {
    name: `12 Hour Format: ${moment().format('ha') || '8am'}`,
    id: '12Hours'
  }
];
